module.exports = __webpack_public_path__ + "img/partner-sejuta-cita.2b228b58.png";